app.mediator.registerModule(MODULE_NAME__CONFIRM_ENTRY_SUBMIT, function (app) {

    // "Private class" variables
    var modal;
    var helpers;

    return {

        modalTitle: 'Confirm submission',
        modalCloseText: 'Close',
        modalSubtitle: 'Unnamed project',

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            modal = app.ui.uiPlugins.modal;
            helpers = app.helpers.funcs;
            this.addDomListeners();
            this.addMediatorListeners();
			
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function () {
            var scope = this;
            modal.getMainModalElem().on('click', '.li-save', function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    return false;
                }
                app.helpers.funcs.loadifyButtons($(this), true);
                app.mediator.notify(EVENT_NAME__CONFIRM_ENTRY_SUBMIT__SAVE_BUTTON_TRIGGERED, {
                    e: e
                });
            });
            modal.getMainModalElem().on('click', '.li-continue-editing', function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    return false;
                }
                modal.hide();
            });
            modal.getMainModalElem().on('click', '.li-submit', function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    return false;
                }
                app.helpers.funcs.loadifyButtons($(this), true);
                app.mediator.notify(EVENT_NAME__CONFIRM_ENTRY_SUBMIT__CONFIRM_BUTTON_TRIGGERED, {
                    e: e
                });
            });
            modal.getMainModalElem().on('hidden.bs.modal', function () {
                var modalWasConfirmEntrySubmitModal = modal.getMainModalElem().find('.confirm-entry-body').length;
                if (modalWasConfirmEntrySubmitModal) {
                    app.mediator.notify(EVENT_NAME__CONFIRM_ENTRY_SUBMIT__MODAL_CLOSED);
                }
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {

            var scope = this;

            app.mediator.addListener(EVENT_NAME__ENTER_FORM__VALID_SUBMIT, function () {
                scope.showModal();
            }, this);

            app.mediator.addListener(EVENT_NAME__ENTER_FORM__PROJECT_NAME_CHANGED, function (data) {
                scope.setSubTitle(data.newProjectName);
            }, this);

            app.mediator.addListener(EVENT_NAME__ENTER_FORM__SUBMIT_UI_DISABLED, function () {
                scope.disableSubmitUi();
            }, this);

        },
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

        // -----------------------------------------------
        // Set language strings
        // -----------------------------------------------

        setTitle: function(title) {
            this.modalTitle = title;
        },

        setSubTitle: function (title) {
            this.modalSubtitle = title;
        },

        setCloseButtonText: function (text) {
            this.modalCloseText = text;
        },

        // -----------------------------------------------
        // Misc
        // -----------------------------------------------

        disableSubmitUi: function () {
            var $rootElem = modal.getMainModalElem();
            var $btns = $rootElem.find('.li-save, .li-continue-editing, .li-submit');
            app.helpers.funcs.loadifyButtons($btns);
        },

        setLoadIndicatorToBtn: function ($btn) {
            var $modalRoot = modal.getMainModalElem();
            app.helpers.funcs.removeLoadIndicatorFromButton($modalRoot.find('.li-save'));
            app.helpers.funcs.removeLoadIndicatorFromButton($modalRoot.find('.li-continue-editing'));
            app.helpers.funcs.removeLoadIndicatorFromButton($modalRoot.find('.li-submit'));
            app.helpers.funcs.addLoadIndicatorToButton($btn);
        },

        showModal: function ($cardElem) {
            modal.addModalClass('confirm-entry-modal confirm-entry-submit-modal', true);
            modal.setSize('md');
            modal.setCloseButtonText(this.modalCloseText);
            modal.setTitle(this.modalTitle);
            modal.setSubTitle(this.modalSubtitle);
            modal.setBodyHtml(this.getBodyHtml() + this.getBtnsHtml());
            modal.show();
        },

        hideModal: function () {
            modal.hide();
        },

        getBodyHtml: function() {
            return '<div class="confirm-entry-body tub">' + $('#confirm-entry-submit-body-template').html() + '</div>';
        },

        getBtnsHtml: function () {
            return $('#confirm-entry-submit-buttons-template').html();
        }
	};
});
